/**
 * A leading list marker someone pasting a list from a document or an email
 * brings along: "-", "*", "•", "1." / "1)", or a "[ ]" / "[x]" box.
 */
const LIST_MARKER = /^\s*(?:[-*•–]|\d+[.)]|\[[ xX]?\])\s+/;

/**
 * Turn typed or pasted text into checklist item texts: one per non-blank
 * line, trimmed, list markers removed, inner whitespace collapsed.
 */
export function parseChecklistInput(text: string): string[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.replace(LIST_MARKER, "").replace(/\s+/g, " ").trim())
    .filter((line) => line.length > 0);
}
